module.exports = __webpack_public_path__ + "static/fonts/CeraPro-Regular.03121bd.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CeraPro-Regular.eot
// module id = RmlP
// module chunks = 1